import React, { Component} from 'react';

export default class RegisterHeader extends Component {

  render() {
   var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
   var day = ['Sunday', 'Monday', 'Tuesday','Wednesday','Thursday', 'Friday', 'Saturday'];
   let d=new Date(), displayDate=d.getDate(),displayYear=d.getFullYear(), displayAMonth=monthNames[d.getMonth()],displayDay=day[d.getDay()];

    return (

     <header>
       <div className="logo"><img src={process.env.PUBLIC_URL+'/images/logo.png'} alt="361&deg;minds&trade;" title="361&deg;minds&trade;" border="0"/></div>
       <div className="top-links"><img src={process.env.PUBLIC_URL+'/images/calendar_icon.png'} alt="" title="" border="0"/> {displayDay}, {displayAMonth} {displayDate}, {displayYear}</div>
     </header>
   
    );
  }

}



// WEBPACK FOOTER //
// ./src/partials/RegisterHeader.js